import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'

export default async function deleteUser(userId: number) {
  return await api.delete(`${URLS.USER_API}/${userId}`)
  .then((response) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Usuário apagado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    })
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}
